import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ITAFBookB3 } from './taf-book-b3-list';

import { HttpHelper } from '../../../shared/http-helper';

import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

@Injectable()
export class TAFBookB3Service {

    //need to have this somewhere besides hardcoded in here

    //private _tafBookB3Url = ` http://localhost:55706/api/systemmanagement/TAFBookB3`;
    private _tafBookB3Url = `api/systemmanagement/TAFBookB3`;
    


    constructor(private httpHelper: HttpHelper) { }

    getTAFBookB3(): Observable<ITAFBookB3> {
         return this.httpHelper.get(`${this._tafBookB3Url}`)
             //.map((response: Response) => <ITAFBookB3> response.json())
             //.do(data => console.log('ITafBookB3: ' +  JSON.stringify(data)))
             //.catch(this.handleError);
    }

   
    private handleError(error: Response) {
         // in a real world app, we may send the server to some remote logging infrastructure
         // instead of just logging it to the console
                 
         console.error(error);
         return Observable.throw(error.json().error || 'Server error');
    }
}


/** WEBPACK FOOTER **
 ** ./app/system-management/tafbooks/taf-book-b3/taf-book-b3.service.ts
 **/